import { Sparkle } from "./Doodles";

/* Тънка лента над хедъра: трите неща, които майките питат първо.
   Контактите и социалните мрежи са във футъра. */
const NOTES = [
  "Рисувано на ръка в Пазарджик",
  "Доставка с Еконт и Спиди в цяла България",
  "Размер, срок и поръчка — направо в чата",
];

export const TopBar = () => (
  <div className="sa-ribbon">
    <ul className="sa-ribbon-list">
      {NOTES.map((note) => (
        <li key={note} className="sa-ribbon-item">
          <Sparkle size={12} color="var(--sa-rose-500)" />
          {note}
        </li>
      ))}
    </ul>
  </div>
);
